import React from "react";
import {
  Flex,
  Text,
  Box,
  Image,
  VStack,
  Button,
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionButton,
} from "@chakra-ui/react";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";

import logo from "../../assets/logo.png";
import kidsImage from "../../assets/register-image-kids.png";

const AuthFAQS = () => {
  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      bg="white"
      position="relative"
    >
      {/* Left Image */}
      <Box
        flex={1}
        justifyContent="flex-end"
        alignItems="flex-end"
        display={"flex"}
      >
        <Image
          src={kidsImage}
          alt="Kids Fashion"
          objectFit="cover"
          width={589}
          height={440}
        />
      </Box>
      {/* Right Content */}
      <Box
        flex={1}
        justifyContent="center"
        alignItems="center"
        display={"flex"}
      >
        <VStack align="flex-center" spacing={6} width={500}>
          <Image src={logo} height={"110px"} />
          <Text
            fontFamily={"PlusJakartaSansMedium"}
            fontSize={"36px"}
            lineHeight={"38px"}
            color={"#000000"}
            textAlign={"center"}
          >
            Frequently Asked Questions
          </Text>

          <VStack align="flex-center" spacing={4}>
            <Accordion
              defaultIndex={[0]}
              allowToggle
              gap={5}
              display={"flex"}
              flexDir={"column"}
              marginTop={3}
            >
              {Array.from({ length: 4 }).map((_, index) => (
                <AccordionItem
                  key={index}
                  borderWidth={"1px"}
                  borderRadius={"6px"}
                  borderColor={"#D9D9D9"}
                  padding={2}
                >
                  {({ isExpanded }) => (
                    <>
                      <h2>
                        <AccordionButton _hover={{ bg: "transparent" }}>
                          <Box flex="1" textAlign="left">
                            <Text
                              fontFamily={"PlusJakartaSansRegular"}
                              fontSize={"20px"}
                              color={"#000000"}
                            >
                              How long does it take to ship my order?
                            </Text>
                          </Box>
                          {isExpanded ? (
                            <VStack
                              width={"24px"}
                              height={"24px"}
                              bg={"#898989"}
                              justifyContent={"center"}
                              alignItems={"center"}
                              borderRadius={"4px"}
                            >
                              <MinusIcon boxSize={3} color="#FFFFFF" />
                            </VStack>
                          ) : (
                            <VStack
                              width={"24px"}
                              height={"24px"}
                              bg={"#456EFF"}
                              justifyContent={"center"}
                              alignItems={"center"}
                              borderRadius={"4px"}
                            >
                              <AddIcon boxSize={3} color="#FFFFFF" />
                            </VStack>
                          )}
                        </AccordionButton>
                      </h2>
                      <AccordionPanel pb={4}>
                        <Text
                          fontFamily={"PlusJakartaSansRegular"}
                          fontSize={"16px"}
                          //   lineHeight={"30px"}
                          color={"#898989"}
                        >
                          Orders are usually shipped within 1–2 business days
                          after placing the order.
                        </Text>
                      </AccordionPanel>
                    </>
                  )}
                </AccordionItem>
              ))}
            </Accordion>
            <VStack alignItems={"flex-end"}>
              <Button
                bgColor={"#456EFF"}
                colorScheme="#456EFF"
                borderRadius={"12px"}
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"16px"}
                lineHeight={"20px"}
                color={"#FFFFFF"}
                // textAlign={"center"}
                w={"150px"}
                h={"48px"}
                marginTop={3}
                // onClick={() => formik.handleSubmit()}
                // isDisabled={isRegisterDisabled}
              >
                Continue
              </Button>
            </VStack>
          </VStack>
        </VStack>
      </Box>
    </Flex>
  );
};

export default AuthFAQS;
